import { createFileRoute } from '@tanstack/react-router';

// relative imports
import ErrorPage from '../../components/error-handling/ErrorPage';

export const Route = createFileRoute('/_public/auth-error')({
  component: ErrorPage as any,
});
